import React from 'react';
import Logo from '../components/Logo';
import { Form, redirect, useNavigation, Link } from 'react-router-dom';
import customFetch from '../utils/customFetch';
import { toast } from 'react-toastify';

export const loader = async ({ request }) => {
  const url = new URL(request.url);
  const token = url.searchParams.get('token');
  const email = url.searchParams.get('email');

  if (!email || !token) {
    return redirect('/login');
  }
  return null;
};

export const action = async ({ request }) => {
  const url = new URL(request.url);
  const token = url.searchParams.get('token');
  const email = url.searchParams.get('email');

  const formData = await request.formData();
  const data = Object.fromEntries(formData);
  const { password, passwordConfirm } = data;
  if (password !== passwordConfirm) {
    return toast.error('Passwörter stimmen nicht überein');
  }
  delete data.passwordConfirm;

  try {
    await customFetch.post('/auth/reset-password', {
      password: data.password,
      token,
      email,
    });
    toast.success('Passwort erfolgreich geändert!');
    return redirect('/login');
  } catch (error) {
    toast.error(error?.response?.data?.msg);
    return error;
  }
};

const ResetPassword = () => {
  const navigation = useNavigation();
  const isSubmitting = navigation.state === 'submitting';
  return (
    <>
      <div className="h-full bg-gray-50" style={{ height: '100vh' }}>
        <div className="h-full">
          <div className="flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8">
            <div className="sm:mx-auto sm:w-full sm:max-w-md">
              <Link to="/">
                <Logo />
              </Link>
              <h2 className="mt-6 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
                Wähle ein neues Passwort
              </h2>
            </div>

            <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-[480px]">
              <div className="bg-white px-6 py-12 shadow-sm sm:rounded-lg sm:px-12">
                <Form className="space-y-6" method="POST">
                  <div>
                    <label
                      htmlFor="password"
                      className="block text-sm font-medium leading-6 text-gray-900"
                    >
                      Passwort
                    </label>
                    <div className="mt-2">
                      <input
                        id="password"
                        name="password"
                        type="password"
                        required
                        className="block w-full rounded-md border-0 px-3 py-1.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-svisit-primary-600 sm:text-sm sm:leading-6"
                      />
                    </div>
                  </div>
                  <div>
                    <label
                      htmlFor="password"
                      className="block text-sm font-medium leading-6 text-gray-900"
                    >
                      Passwort bestätigen
                    </label>
                    <div className="mt-2">
                      <input
                        id="passwordConfirm"
                        name="passwordConfirm"
                        type="password"
                        required
                        className="block w-full rounded-md border-0 px-3 py-1.5 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-svisit-primary-600 sm:text-sm sm:leading-6"
                      />
                    </div>
                  </div>

                  <div>
                    <button
                      type="submit"
                      className="flex w-full justify-center rounded-md bg-svisit-primary-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-xs hover:bg-svisit-primary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-svisit-primary-600"
                      disabled={isSubmitting}
                    >
                      {isSubmitting
                        ? 'Passwort wird zurückgesetzt...'
                        : 'Passwort zurücksetzen'}
                    </button>
                  </div>
                </Form>
                <Link to="/login">
                  <div className="mt-4">
                    <button
                      type="button"
                      className="flex w-full justify-center rounded-md bg-white px-3 px-3 py-1.5 text-sm font-semibold leading-6 text-gray-900 shadow-xs ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                    >
                      Zurück zum Login
                    </button>
                  </div>
                </Link>
              </div>

              {/* <p className="mt-10 text-center text-sm text-gray-500">
                Noch kein Kunde?{' '}
                <a
                  href="#"
                  className="font-semibold leading-6 text-svisit-primary-600 hover:text-svisit-primary-500"
                >
                  Jetzt gratis testen!
                </a>
              </p> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
